import {
    DEAKIN_TOPICS_FACET_ID,
    DEAKIN_FACULTY_FACET_ID,
    DEAKIN_TAGS_FACET_ID,
    facetValueToSlug,
    resolveTopicFacetValue,
    resolveFacultyFacetValue,
} from './funnelback/deakin-config';

type TaxonomyKind = 'category' | 'tag' | 'faculty';

function buildSearchHref(
    searchPageUrl: string,
    facetId: string,
    facetValue: string,
): string {
    const params = new URLSearchParams();
    params.set(`f.${facetId}`, facetValue);
    return `${searchPageUrl}?${params.toString()}`;
}

function resolveFacetValue(kind: TaxonomyKind, rawValue: string): string {
    if (kind === 'category') {
        return resolveTopicFacetValue(rawValue);
    }
    if (kind === 'faculty') {
        return resolveFacultyFacetValue(rawValue);
    }
    return facetValueToSlug(rawValue);
}

export function initialiseTaxonomy(): void {
    const taxonomyLists =
        document.querySelectorAll<HTMLUListElement>('[data-taxonomy-split]');

    taxonomyLists.forEach((list) => {
        const rawValue = list.dataset.taxonomySplit?.trim();
        const taxonomyKind =
            list.dataset.taxonomyKind as TaxonomyKind | undefined;

        const section =
            list.closest<HTMLElement>('.des-taxonomy-group') ??
            list.closest<HTMLElement>('section');

        if (!rawValue) {
            if (section) section.hidden = true;
            return;
        }

        const container = list.closest<HTMLElement>('[data-search-url]');
        const searchPageUrl = container?.dataset.searchUrl?.trim() ?? '';

        // Prevent duplicate entries if initialisation runs again.
        list.replaceChildren();

        const values = rawValue
            .split(';')
            .map((value) => value.trim())
            .filter((value) => value.length > 0);

        const uniqueValues = [...new Set(values)];

        if (uniqueValues.length === 0) {
            if (section) section.hidden = true;
            return;
        }

        if (section) section.hidden = false;

        uniqueValues.forEach((value) => {
            const cleanValue = value.replace(/^#+/, '');

            const displayValue =
                taxonomyKind === 'tag'
                    ? `#${cleanValue}`
                    : cleanValue;

            const listItem = document.createElement('li');
            const link = document.createElement('a');

            link.className = 'des-taxonomy-badge';

            if (searchPageUrl && taxonomyKind) {
                const facetId =
                    taxonomyKind === 'category'
                        ? DEAKIN_TOPICS_FACET_ID
                        : taxonomyKind === 'faculty'
                        ? DEAKIN_FACULTY_FACET_ID
                        : DEAKIN_TAGS_FACET_ID;
                const facetValue = resolveFacetValue(taxonomyKind, cleanValue);
                link.href = buildSearchHref(searchPageUrl, facetId, facetValue);
            } else {
                link.href = '#';
            }

            link.textContent = displayValue;

            listItem.appendChild(link);
            list.appendChild(listItem);
        });
    });
}

function runTaxonomyInitialisation(): void {
    initialiseTaxonomy();
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        runTaxonomyInitialisation
    );
} else {
    runTaxonomyInitialisation();
}

// Rebuild after Squiz live-preview content updates.
document.addEventListener('livePreviewUpdated', () => {
    window.setTimeout(runTaxonomyInitialisation, 100);
});